import { User } from '@/domain/entities/user/user'
import { AuthRepository } from '@/domain/repositories/auth/AuthRepository'

export class CheckSessionUseCase {
  constructor(private authRepository: AuthRepository) {}

  async checkSession(): Promise<User> {
    try {
      const data = await this.authRepository.checkSession()
      return data
    } catch (error) {
      console.error(`Error in CheckSessionUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
